import { TrackingType } from "UidispatcherApiModule";
const { Tracking }: { Tracking: TrackingType } =
    // @ts-expect-error
    await import("uidispatcher_api/UidispatcherApiModule");
export default Tracking;
